import * as React from "react";
import { forwardRef } from "react";
const SvgNumberListIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M1.875 12.75H3.375V13.125H2.625V13.875H3.375V14.25H1.875V15H4.125V12H1.875V12.75ZM2.625 6H3.375V3H1.875V3.75H2.625V6ZM1.875 8.25H3.225L1.875 9.825V10.5H4.125V9.75H2.775L4.125 8.175V7.5H1.875V8.25ZM5.625 3.75V5.25H16.125V3.75H5.625ZM5.625 14.25H16.125V12.75H5.625V14.25ZM5.625 9.75H16.125V8.25H5.625V9.75Z", fill: "#4555D6" }));
const ForwardRef = forwardRef(SvgNumberListIcon);
export { ForwardRef as ReactComponent };
